import React from 'react';
import PropTypes from 'prop-types';
import SovosEditableSlidingPanel from 's1-ui/sovos-sliding-panel/SovosEditableSlidingPanel';
import SovosRaisedButton from 's1-ui/sovos-raised-button/SovosRaisedButton';
import BootstrapCard from "shared/components/bootstrapCard/BootstrapCard";
import MapColumns from 'shared/components/mapColumns/MapColumnsConnector';
import { EXCEL_FILE, getFileTypeCategory, PLAIN_TEXT_FILE } from 'shared/helpers/fileTransferHelper';
import {
  NEW, SLIDING_PANEL_DIALOG_ACTION_LABEL,
  SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME,
  SLIDING_PANEL_DIALOG_TEXT,
  SLIDING_PANEL_DIALOG_TITLE,
  UPDATE,
  SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
} from 'shared/constants/SharedConstants';

class ColumnMappingPanel extends React.Component {
  state = {
    mappingPanelOpen: false
  };

  componentWillReceiveProps(nextProps) {
    if(this.props.mode === UPDATE) {
      if(!nextProps.fetchingTargetFields && this.props.fetchingTargetFields) {
        this.props.targetFieldsActions.disableMappedTargetFields(this.props.mappedFields);
      }
    }
  }

  resetMappingInformation = () => this.props.mappingActions.resetImportMappingData(this.props.fileExtension);

  handleMappingPanelClose = () => {
    this.setState({ mappingPanelOpen: false });
  };

  restoreMapAndCloseMappingPanel = () => {
    this.props.mappingActions.restoreMappedFields();
    this.props.profileTTActions.restoreTranslationTables();
    this.handleMappingPanelClose();
  };

  handleMappingPanelOpen = () => {
    this.props.mappingActions.backupMappedFields();
    this.props.profileTTActions.backupTranslationTables();
    this.setState({ mappingPanelOpen: true });
  };

  handlePlainTextFiles = () => {
    this.handleMappingPanelOpen();
  };

  handleExcelFiles = () => {
    const { acceptedFiles, filesActions: { getFileMappingInfo } } = this.props;
    getFileMappingInfo({
      files: acceptedFiles,
      additionalInformation: {identifierPosition: 1, identifiers: [''], delimiter:''},
      url: 'utm/v1/source-file/columns'
    });
    this.handleMappingPanelOpen();
  };

  handleManageColumnsClick = () => {
    const { fileExtension, columnDelimiter, mode, targetFields } = this.props;
    if(targetFields.length > 0) {
      if(fileExtension) {
        switch (getFileTypeCategory(fileExtension)) {
          case PLAIN_TEXT_FILE:
            if (columnDelimiter) {
              this.handlePlainTextFiles();
            }
            break;
          case EXCEL_FILE:
            this.handleExcelFiles();
            break;
        }
      }
      if(mode === UPDATE) {
        this.handleMappingPanelOpen();
      }
    }
  };

  handleAddMapAndTTToProfile = () => {
    this.props.profileActions.addMappedFieldsToProfile(this.props.mappedFields);
    this.handleMappingPanelClose();
  };

  handleResetMapping = () => this.resetMappingInformation();

  render() {
    const {
      mappedFieldsCount,
      acceptedFiles,
      fetchingProfile,
      fetchingTargetFields,
      mappedFields,
      remainingRequiredFieldsCount
    } = this.props;
    return (
      <React.Fragment>
        <BootstrapCard 
          title="4. Column Mapping" 
          loading={ fetchingProfile || fetchingTargetFields } 
          margin={ '15px 0' }
        >
          <div className="manage-imp-profile__column-mapping-text">{ (mappedFieldsCount === 0) ? 'No Columns mapped' : `${mappedFieldsCount} Columns mapped`}</div>
          <div className="manage-imp-profile__column-mapping-open" onClick={ this.handleManageColumnsClick }>Manage Columns</div>
        </BootstrapCard>
        <SovosEditableSlidingPanel
          title="Column Mapping Setup"
          isDirty={ () => true }
          contentStyle={ { padding: 0 } }
          open={ this.state.mappingPanelOpen }
          onClose={ this.restoreMapAndCloseMappingPanel }
          baseWidth={ '1080px' }
          SaveButtonProps={
            {
              onClick: this.handleAddMapAndTTToProfile,
              disabled: (mappedFields.length === 0 || remainingRequiredFieldsCount > 0),
              children: 'ADD TO PROFILE'
            }
          }
          CancelButtonProps={
            {
              children: 'CLOSE',
              className: 'column-mapping__button'
            }
          }
          CloseDialogProps={ {
            DialogTitleProps: {
              children: SLIDING_PANEL_DIALOG_TITLE,
              className: SLIDING_PANEL_DIALOG_TITLE_CLASS_NAME
            },
            DialogContentProps: {
              children: SLIDING_PANEL_DIALOG_TEXT,
              className: SLIDING_PANEL_DIALOG_CONTENT_CLASS_NAME
            },
            OKButtonProps: {
              children: SLIDING_PANEL_DIALOG_ACTION_LABEL
            },
            CancelButtonProps: {
              children: 'CLOSE'
            }
          } }
          additionalButtons={ [ <SovosRaisedButton key={ 'reset-all' } color="secondary" onClick={ this.handleResetMapping } >RESET ALL</SovosRaisedButton> ] }
        >
          <MapColumns acceptedFiles={ acceptedFiles } />
        </SovosEditableSlidingPanel>
      </React.Fragment>
    );
  }
}

ColumnMappingPanel.propTypes = {
  mappedFieldsCount: PropTypes.number.isRequired,
  fileExtension: PropTypes.string.isRequired,
  fileName: PropTypes.string.isRequired,
  acceptedFiles: PropTypes.arrayOf(PropTypes.object),
  columnDelimiter: PropTypes.string.isRequired,
  mappedFields: PropTypes.array.isRequired,
  mode: PropTypes.string,
  fetchingTargetFields: PropTypes.bool.isRequired,
  fetchingProfile: PropTypes.bool.isRequired,
  targetFields: PropTypes.array.isRequired,
  remainingRequiredFieldsCount: PropTypes.number.isRequired,
  filesActions: PropTypes.shape({
    getFileMappingInfo: PropTypes.func
  }).isRequired,
  mappingActions: PropTypes.shape({
    resetImportMappingData: PropTypes.func,
    backupMappedFields: PropTypes.func,
    restoreMappedFields: PropTypes.func
  }).isRequired,
  profileActions: PropTypes.shape({
    addMappedFieldsToProfile: PropTypes.func
  }).isRequired,
  targetFieldsActions: PropTypes.shape({
    disableMappedTargetFields: PropTypes.func
  }).isRequired,
  profileTTActions: PropTypes.shape({
    backupTranslationTables: PropTypes.func,
    restoreTranslationTables: PropTypes.func
  }).isRequired
};

ColumnMappingPanel.defaultProps = {
  mode: NEW
};

export default ColumnMappingPanel;




// WEBPACK FOOTER //
// ./src/components/importProfile/comp/columnMappingPanel/ColumnMappingPanel.js